// Values are class names from ./styles.scss
export enum TagVariant {
  // Iron
  Iron050 = 'iron--050',
  Iron100 = 'iron--100',

  // Practical
  Practical025 = 'practical--025',
  Practical100 = 'practical--100',
  Practical200 = 'practical--200',
  Practical300 = 'practical--300',
  Practical500 = 'practical--500',
  Practical900 = 'practical--900',

  // Magic
  Magic200 = 'magic--200',
  Magic600 = 'magic--600',

  // Crimson
  Crimson600 = 'crimson--600',

  // West
  West100 = 'west--100',
  West200 = 'west--200',

  // Electric
  Electric050 = 'electric--050',

  // Rfq statuses
  RfqE1Created = 'rfq--e1-created',
  RfqStatusApproved = 'rfq-status--approved',
  RfqStatusNoResponse = 'rfq-status--no-response',
  RfqStatusQuoted = 'rfq-status--quoted',
  RfqStatusQuoting = 'rfq-status--quoting',
  RfqStatusNotQuoting = 'rfq-status--not-quoting',
  RfqHasDocs = 'rfq--has-docs',
  RfqDocsDownloaded = 'rfq--docs-downloaded',
  RfqDocsObsolete = 'rfq--docs-obsolete',
  RfqDocsHardCopy = 'rfq--docs-hard-copy',

  // Watchlist interest levels
  WatchlistInterested = 'watchlist--interested',
  WatchlistQuoting = 'watchlist--quoting',
  WatchlistQuoted = 'watchlist--quoted',

  // stocktrade tag
  StockTrade = 'stocktrade',

  // Network tags
  NetworkReadonly = 'network--readonly',
  NetworkWritable = 'network--writable',

  // Document status tags
  DocsCurrent = 'docs--current',
  DocsObsolete = 'docs--obsolete',
  DocsNotAccessed = 'docs--not-accessed',

  // General tags
  Warning = 'warning',
  Danger = 'danger',
  Error = 'error',
  Plain = 'plain',
  Situational = 'situational',
  Disabled = 'disabled',
}
